// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__mNPqW","tabsCentered":"Tabs_tabsCentered__1rs-C"};